<template>
  <div class="page page-create-serve">
    <HeaderTitle />
    <div class="form-group">
      <label for="serviceDate">Дата/время обслуживания</label>
      <input
        id="serviceDate"
        v-model="service.datetime"
        type="datetime-local"
        class="form-control"
        aria-describedby="emailHelp"
        placeholder="Введите дату/время обслуживания"
        :max="now()"
      >
    </div>
    <div class="form-group">
      <label for="factMileage">Фактические показания одометра</label>
      <input
        id="factMileage"
        v-model="service.total_odometer_stamp"
        type="number"
        class="form-control"
        aria-describedby="emailHelp"
        placeholder="Введите значение одометра"
      >
    </div>
    <div role="button" class="d-inline-block" @click="showWorks = !showWorks">
      <span>Выполненные работы</span>
      <font-awesome-icon
        :icon="showWorks ? 'chevron-up' : 'chevron-down'"
        class="text-secondary"
        style="margin-left: 10px"
      />
    </div>
    <div v-if="showWorks" class="d-flex flex-column">
      <div class="input-group without-separator">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <font-awesome-icon icon="search" style="color:gray" />
          </span>
        </div>
        <input
          type="text"
          class="form-control"
          placeholder="Поиск по имени и интервалу"
          aria-label="Поиск по имени и интервалу"
          :value="searchText"
          @input="searchServiceWork"
        >
      </div>
    </div>
    <div v-if="showWorks" class="draggable-cards-wrapper">
      <DraggableTree
        ref="tree"
        class="tree4"
        :data="works"
        :indent="30"
        :space="0"
      >
        <div slot-scope="{data, store}">
          <template v-if="!data.isDragPlaceHolder">
            <div class="row" style="margin-left: 0">
              <div
                class="col row text-dark py-2"
              >
                <div class="col row">
                  <font-awesome-icon
                    v-if="data.children && data.children.length"
                    :icon="data.open ? 'chevron-up' : 'chevron-down'"
                    class="mr-2"
                    :style="{
                      color: 'gray',
                      'margin-left': 'auto',
                      cursor: 'pointer'
                    }"
                    @click="openChildrenList(data, store)"
                  />
                  <input
                    :id="`checkbox${data.id}`"
                    :ref="`checkbox${data.id}`"
                    v-model="data.selected"
                    type="checkbox"
                    class="mr-2"
                    @change="childrenCheckAll(data)"
                  >
                  <div class="col" @click="openChildrenList(data, store)">
                    <TextHighlight :queries="searchText">
                      {{ data.name }}
                    </TextHighlight>
                    <TextHighlight
                      class="badge"
                      style="line-height: unset"
                      :queries="searchText"
                    >
                      {{ data.interval ? `Каждые ${data.interval} км.` : "" }}
                    </TextHighlight>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </DraggableTree>
    </div>
    <br>
    <StockItemsEdit :current-stocks="currentStocks" />
    <br>
    <ConsumableEdit :consumable="service.consumable" />
    <br>
    <div class="form-group">
      <label>Прочие работы</label>
      <textarea v-model="service.notes" class="form-control" rows="6" />
    </div>
    <br>
    <div class="form-group">
      <label for="exampleFormControlTextarea1">Рекомендации по ремонту</label>
      <textarea
        id="exampleFormControlTextarea1"
        v-model="service.recommendations"
        class="form-control"
        rows="6"
      />
    </div>
    <button class="btn btn-primary mr-2" @click="createServe()">Добавить</button>
    <router-link class="btn btn-secondary" style="margin-right: 10px;" :to="`/maintenance/car/${carId}`">Отмена</router-link>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapState, mapActions } from 'vuex'
import userApi from '@/api/user'
import serviceApi from '../../api/service'
import { djsMixin } from '@/mixins/djsMixin'
import StockItemsEdit from '@/modules/maintenance/components/StockItemsEdit'
import ConsumableEdit from '@/modules/maintenance/components/ConsumableEdit'

export default {
  name: 'CreateService',
  components: {ConsumableEdit, StockItemsEdit},
  mixins: [djsMixin],
  props: {
    carId: {
      type: String,
      default: '0'
    },
  },
  data () {
    return {
      worksSelected: [],
      service: {
        car_id: this.carId,
        total_odometer_stamp: null,
        author_id: null,
        datetime: this.now(),
        notes: null,
        recommendations: null,
        consumable: []
      },
      isCreating: false,
      currentStocks: [],
      interval: null,
      showWorks: true
    }
  },
  computed: {
    ...mapState('taxi/cars', {
      car (state) {
        return state.items.find(el => el.id == this.carId)
      },
      isLoading: state => state.isLoading
    }),
    ...mapState('maintenance/serviceWork', {
      worksState: state => state.items.filter(e => !e.archived_at),
      isLoading: state => state.isLoading,
      searchText: state => state.searchText
    }),
    works () {
      if (this.worksState.length <= 0) {
        return []
      }
      if (this.worksSelected.length <= 0) {
        return JSON.parse(JSON.stringify(this.worksState))
      }
      this.updateSelected(this.worksState)
      return JSON.parse(JSON.stringify(this.worksState))
    }
  },
  mounted () {
    this.loadItem({ id: this.carId })
    this.setTitle([
      {
        title: 'Тех. обслуживание',
        url: '/maintenance'
      }, {
        title: 'Добавить'
      }
    ])
    if (!this.interval) {
      this.loadWithSearch()
    }
  },
  beforeDestroy () {
    this.abortLoading()
    clearTimeout(this.interval)
    this.interval = null
  },
  methods: {
    ...mapActions('taxi/cars', [
      'loadItem'
    ]),
    ...mapActions('maintenance/serviceWork', [
      'loadItems',
      'abortLoading',
      'setSearch',
      'setSearchText'
    ]),
    ...mapActions('taxi', [
      'setTitle'
    ]),
    openChildrenList (data, store) {
      if (!data.children || !data.children.length) {
        data.selected = !data.selected
        this.childrenCheckAll(data)
      }
      store.toggleOpen(data)
    },
    childrenCheckAll (data) {
      let value = data.selected
      if (value) {
        this.worksSelected.push(data.id)
      } else {
        this.worksSelected = this.worksSelected.filter(id => id !== data.id)
      }
      data.children.forEach(child => {
        child.selected = value
        this.childrenCheckAll(child)
      })
      this.updateSelected(this.worksState)
    },
    updateSelected (array) {
      if (array.length <= 0) {
        return
      }
      array.forEach(el => {
        el.selected = this.worksSelected.includes(el.id)
        this.updateSelected(el.children)
      })
    },
    createServe () {
      if (this.isCreating) return
      userApi
        .getCurrentUser()
        .then(user => {
          this.isCreating = true
          serviceApi.createItem({
            ...this.service,
            datetime: this.toUTCtranslate(this.service.datetime),
            car_id: this.carId,
            author_id: user.id,
            worksRelatedIds: this.worksSelected,
            currentStocks: this.currentStocks,
            сonsumable: this.service.consumable
          })
            .then(() => {
              this.isCreating = false
              this.$router.push(`/maintenance/car/${this.carId}`)
            })
            .catch(err => {
              console.error(err)
              this.isCreating = false
              Swal.fire({
                icon: 'error',
                title: 'Ошибка',
                html: err.message
              })
            })
        })
        .catch(err => {
          console.error(err)
          this.isCreating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: err.message
          })
        })
    },
    setOpenProp (works) {
      works.forEach(work => {
        work.open = false
        if (work.children.length) {
          this.setOpenProp(work.children)
        }
      })
    },
    loadWithSearch () {
      if (!this.isLoading && this.searchedText !== this.searchText) {
        this.searchedText = this.searchText
        return this.loadItems({
          page: Number(this.page)
        }).then(() => {
          this.interval = setTimeout(() => { this.loadWithSearch() }, 500)
        })
      }
      this.interval = setTimeout(() => { this.loadWithSearch() }, 500)
    },
    searchServiceWork (e) {
      this.setSearchText(e.target.value)
      this.setSearch({ key: 'name', value: e.target.value })
      this.setSearch({ key: 'interval', value: e.target.value })
    },
  }
}
</script>

<style scoped>
  .page-create-serve {
    width: 98%;
    padding-bottom: 4rem;
  }
  ::v-deep .tree-node-inner:hover {
    cursor: pointer !important;
  }
</style>
